import { useMemo } from "react"

import { Typography } from "@l2r-front/l2r-ui"
import { formatMetersToDistance } from "@l2r-front/l2r-utils"

import { useRoadwork } from "../../hooks/queries/useRoadwork"
import { computeRoadworkLength } from "../../utils/roadworkUtils"

import * as Style from "./RoadworkSectionLength.styled"

export const RoadworkSectionLength = (props) => {

    const { roadworkUuid } = props

    const { data: roadworkFeature, isLoading, isError } = useRoadwork(roadworkUuid, null, {}, { "as_geojson": true })

    const roadLength = useMemo(() => {
        if (!roadworkFeature?.linearLocation?.length) {
            return "-"
        }

        const lengthInMeters = computeRoadworkLength(roadworkFeature.linearLocation)

        return formatMetersToDistance(lengthInMeters)
    }, [roadworkFeature])

    if (isError) {
        return null
    }

    if (isLoading) {
        return <Style.Skeleton />
    }

    return (
        <Typography id="road-detail-length" variant="Desktop & Mobile/Body/Regular">{roadLength}</Typography>
    )
}